module.exports = __webpack_public_path__ + "static/media/learning-17.bb2c428b.png";